module.exports = __webpack_public_path__ + "static/media/bolt.6813e584.svg";